import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/stdapplinf/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/stdapplinf/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/stdapplinf/getIndex?numappl=' + searchParams.numappl)
  },
  getTappoinf (searchParams) {
    if (isMock) return generator(mocker.tappoinf())
    return instance().get(endpoint + '/stdapplinf/getTappoinf?numappl=' + searchParams.numappl + '&numreqrq=' + searchParams.numreqrq + '&codposrq=' + searchParams.codposrq)
  }
}



// WEBPACK FOOTER //
// ./src/api/stdapplinf/index.js